<i18n>
{    
    "en": {
        "sections": {
            "1": {
                "title": "Weaving comfort & elegance into every thread",
                "subtitle": "At Four Seasons International, we design, manufacture and craft home textile products that enlightens every home. Your home our way.",
                "subtitle1": ""
            },            
            "actions": {
                "contact": "Contact Us",
                "about": "More About Us",
                "products": "Our Products"
            },
            "about": {
                "title": "About Us",
                "subtitle": "Your vision, our expertise",
                "row1": {
                    "title": "Who we are, What we do, and What are our goals?",
                    "content": "The rich experience of the founding family is being carried forward translating into slick and contemporary designs under the leadership of the third generation. Sticking to our roots and our traditions, we do not shy away from experimenting with the desires of the market, creating our own trends."
                },
                "row2": {
                    "title": "We innovate",
                    "content": "We continuously research on new products, processes and fabrications that benefit our customers in terms of being design conscious and price competitive. Our in-house designers are fully equipped to conceptualize new designs as well as meet specific custom requirements."
                },
                "row3": {
                    "title": "World wide",
                    "content": "We take pride in our ability to cater to customers worldwide. We are committed to providing high-quality textile products to buyers from all corners of the world. Our international shipping ensure that our customers receive their orders promptly and efficiently, no matter where they are located."
                },
                "row4": {
                    "title": "We do best",
                    "content": "Every client has a specific custom requirement that we deliver at the highest level of quality possible. From needle check to in-house testing labs, only the right product gets exported. Making every thread count!"
                }
            },            
            "industries": {
                "title": "We are very Best at",
                "subtitle": "Our company takes great pride in offering a diverse range of top-notch textile products, and we stand by our values of excellence and quality.",
                "cols": [
                    {
                        "headline": "Quality",
                        "description": " Strict quality control, checking products at every stage of production to meet international standards, from raw materials to packaging & shipping."
                    },
                    {
                        "headline": "Culture",
                        "description": "Our company has been recognized as a friendly workplace, providing a positive working environment for our staff and workers."
                    },
                    {
                        "headline": "Innovation",
                        "description": "Stay competitive by adopting new trends, technologies, and methods while adding value to their products and services."
                    }
                ]
            },
            "timeline": {
                "title": "We are Certified",
                "subtitle": "Our Certification include Sedex, GOTS, BSCI, and BCI"
            },
            "products": {
                "title": "Our Products",
                "subtitle": "Our goal is to provide a wide selection of premium textile products that are crafted to not only add visual appeal but also improve the practicality of any home."
            },            
            "contact": {
                "subtitle": "Leave us a message and we'll reply as soon as possible"
            }
        },
        "timeline": [
            {
                "title": "",
                "content": ""
            },
            {
                "title": "",
                "content": ""
            }
        ],
        "contact": {
            "subheader": "or contact us via:",
            "email": "Email Address",
            "address": "Address",
            "website": "Website"
        }
    }
}
</i18n>
<template>
  <div class="page page-sections mt-4">
    <!-- home -->
    <section
      id="headerSection"
      data-section="home"
      class="header-section fullpage-section"
    >
      <v-container
        v-if="!loading"
        class="fill-height pt-12"
        :class="{ 'align-center': phoneOnly }"
      >
        <v-slide-y-transition appear>
          <h1 class="strong-text--text">
            <animate-text
              :duration="1500"
              :stop-after="0"
              :delay="500"
              :text="$t('sections.1.title')"
              :subTitleFont="false"
              :device="pcOnly"
            />
          </h1>
        </v-slide-y-transition>
        <v-slide-x-transition appear>
          <h2 class="text--text mt-5 white--text">
            <animate-text
              @done="showSection1Actions = true"
              :duration="2500"
              :delay="2000"
              :text="$t('sections.1.subtitle')"
              :subTitleFont="true"
              :device="pcOnly"
            ></animate-text>
          </h2>
        </v-slide-x-transition>
        <div
          v-if="pcOnly"
          class="actions"
          :class="{
            'fade-up-off': !showSection1Actions,
            'fade-up-on': showSection1Actions,
          }"
        >
          <v-btn
            @click="navigateToLink('#aboutSection')"
            color="white"
            tile
            :large="pcOnly"
            depressed
            rounded
            class="me-6"
            >{{ $t("sections.actions.about") }}</v-btn
          >
          <v-btn
            @click="navigateToLink('#contactSection')"
            color="primary"
            tile
            :large="pcOnly"
            rounded
            >{{ $t("sections.actions.contact") }}</v-btn
          >
        </div>
      </v-container>

      <div class="section-scroll-icon">
        <scroll-icon @click="scrollToSection(2)" />
      </div>
    </section>

    <!-- aboutus -->
    <e-section
      id="aboutSection"
      data-section="about"
      :headline="$t('sections.about.title')"
      :subtitle="$t('sections.about.subtitle')"
      :cols="section2Columns"
      background="dark"
      light
      divider
    >
      <v-row>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'"
          data-aos-duration="800"
          :cols="pcOnly ? 5 : 12"
          class=""
        >
          <v-img
            src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/About%20us/about-1.png?updatedAt=1691473726649"
            width="100%"
            max-height="320"
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div> </template
          ></v-img>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'"
          data-aos-duration="800"
          class="mt-6 mt-lg-0"
          :cols="pcOnly ? 6 : 12"
        >
          <h1 class="headline">{{ $t("sections.about.row1.title") }}</h1>
          <p
            class="medium-text text-light--text mt-6 mt-lg-8"
            :class="{ 'text-center': phoneOnly }"
          >
            {{ $t("sections.about.row1.content") }}
          </p>
        </v-col>
      </v-row>
      <v-row style="margin-top: 3.5rem" class="flex-row-reverse">
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'"
          data-aos-duration="800"
          :cols="pcOnly ? 5 : 12"
          class=""
        >
          <v-img
            src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/About%20us/about-2.png?updatedAt=1691473726670"
            width="100%"
            max-height="320"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div> </template
          ></v-img>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'"
          data-aos-duration="800"
          class="mt-6 mt-lg-0"
          :cols="pcOnly ? 6 : 12"
        >
          <h1 class="headline">{{ $t("sections.about.row2.title") }}</h1>
          <p
            class="medium-text text-light--text mt-6 mt-lg-8"
            :class="{ 'text-center': phoneOnly }"
          >
            {{ $t("sections.about.row2.content") }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'"
          data-aos-duration="800"
          :cols="pcOnly ? 5 : 12"
          class=""
        >
          <v-img
            src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/About%20us/about-3.png?updatedAt=1691473726771"
            width="100%"
            max-height="320"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div> </template
          ></v-img>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'"
          data-aos-duration="800"
          class="mt-6 mt-lg-0"
          :cols="pcOnly ? 6 : 12"
        >
          <h1 class="headline">{{ $t("sections.about.row3.title") }}</h1>
          <p
            class="medium-text text-light--text mt-6 mt-lg-8"
            :class="{ 'text-center': phoneOnly }"
          >
            {{ $t("sections.about.row3.content") }}
          </p>
        </v-col>
      </v-row>
      <v-row style="margin-top: 3.5rem" class="flex-row-reverse">
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'"
          data-aos-duration="800"
          :cols="pcOnly ? 5 : 12"
          class=""
        >
          <v-img
            src="https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/About%20us/about-4.png?updatedAt=1691473726657"
            width="100%"
            max-height="320"
            ><template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="grey-lighten-4"
                  indeterminate
                ></v-progress-circular>
              </div> </template
          ></v-img>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'"
          data-aos-duration="800"
          class="mt-6 mt-lg-0"
          :cols="pcOnly ? 6 : 12"
        >
          <h1 class="headline">{{ $t("sections.about.row4.title") }}</h1>
          <p
            class="medium-text text-light--text mt-6 mt-lg-8"
            :class="{ 'text-center': phoneOnly }"
          >
            {{ $t("sections.about.row4.content") }}
          </p>
        </v-col>
      </v-row>
    </e-section>
    <!-- aboutus1 -->
    <cols-section
      id="industriesSection"
      :headline="$t('sections.industries.title')"
      :subtitle="$t('sections.industries.subtitle')"
      :cols="industriesCols"
      background="light"
    >
    </cols-section>
    <!-- certifications -->
    <e-section
      id="timelineSection"
      data-section="timeline"
      background="dark"
      divider
      :headline="$t('sections.timeline.title')"
      :subtitle="$t('sections.timeline.subtitle')"
      light
    >
      <certifications />
    </e-section>
    <!-- products -->
    <e-section
      id="productsSection"
      data-section="products"
      background="light"
      :headline="$t('sections.products.title')"
      :subtitle="$t('sections.products.subtitle')"
      light
    >
      <v-row class="mt-10 flex-wrap justify-center product-section">
        <v-col
          v-for="(project, i) in productsDetails"
          :key="i"
          :cols="pcOnly ? 12 : 12"
        >
          <v-card
            v-ripple="project.href ? { class: 'soft-ripple' } : false"
            class="card-shadow fill-height mx-auto"
            data-aos="fade-up"
            :data-aos-duration="800"
            :data-aos-delay="400 * i"
            :href="project.href ? project.href : ''"
            :target="project.href ? '_blank' : ''"
          >
            <v-carousel
              class="mb-15"
              height="600"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(item, i) in project.imageset"
                :key="i"
                :src="item.src"
                reverse-transition="fade-transition"
                transition="fade-transition"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                      color="grey-lighten-4"
                      indeterminate
                    ></v-progress-circular>
                  </div> </template
              ></v-carousel-item>
            </v-carousel>
            <div class="py-1 px-3">
              <v-card-title class="product-headline mb-1">{{
                project.title
              }}</v-card-title>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </e-section>
    <!-- contactus -->
    <e-section-footer
      id="contactSection"
      class="contact-section"
      data-section="contact"
      :headline="$t('links.contact')"
      :subtitle="$t('sections.contact.subtitle')"
      light
    >
    </e-section-footer>
    <!-- gallery -->

    <!-- footer -->
    <e-footer />
    <scroll-to-top />
  </div>
</template>

<script>
// @ is an alias to /src
import "particles.js";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// import Navbar from '@/components/main/navbar'
import ScrollToTop from "@/components/custom/scroll-to-top";
import AnimateText from "@/components/custom/animate-text";
import ScrollIcon from "@/components/custom/scroll-icon";
import ColsSection from "@/components/default/cols-section";
import ESection from "@/components/default/e-section";
import Certifications from "@/components/custom/certifications";
import ESectionFooter from "@/components/default/e-section-footer";
import EFooter from "@/components/main/e-footer";

import GlobalComputed from "@/helpers/global-computed";
import GlobalMethods from "@/helpers/global-methods";

import productsDetails from "@/helpers/product-details";

export default {
  name: "Home",
  components: {
    // Navbar,
    ScrollToTop,
    AnimateText,
    Certifications,
    ColsSection,
    ESection,
    ScrollIcon,
    ESectionFooter,
    EFooter,
  },
  data() {
    return {
      visibleIndex: -1,
      showSection1Actions: false,
      currentScrollTop: 0,
      productsDetails,
      selectedItem: 0,
      contactItems: [
        {
          name: "email",
          icon: "mdi-email",
          value: "senthil@four-seasons.in",
          color: "primary",
        },
        {
          name: "address",
          icon: "mdi-map",
          value:
            "162/2, AndanKovil West Village, Athur Pirivu, Athur, Karur 639002. INDIA.",
          color: "blue darken-1",
        },
        {
          name: "website",
          icon: "mdi-web",
          value: "www.four-seasons.in",
          color: "grey",
          href: "",
        },
      ],
      teamMembers: [
        {
          name: "Muthu",
          job: "Founder, CEO & Developer",
          avatar: "",
          description: "Founder and CEO of M company ",
        },
      ],
    };
  },
  computed: {
    industriesCols() {
      return [
        {
          color: "primary",
          icon: "mdi-shield-check",
          headline: this.$t("sections.industries.cols.0.headline"),
          description: this.$t("sections.industries.cols.0.description"),
        },
        {
          color: "yellow",
          icon: "mdi-account-group",
          headline: this.$t("sections.industries.cols.1.headline"),
          description: this.$t("sections.industries.cols.1.description"),
        },
        {
          color: "red",
          icon: "mdi-wallet-giftcard",
          headline: this.$t("sections.industries.cols.2.headline"),
          description: this.$t("sections.industries.cols.2.description"),
        },
      ];
    },
    timeline() {
      return [
        {
          date: "BETTER COTTON",
          title: this.$t("timeline.1.title"),
          content: this.$t("timeline.1.content"),
          image:
            "https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Product%20Catalogue/Certification/PNG%204.png?updatedAt=1691473277330",
        },
      ];
    },
    ...GlobalComputed,
  },
  methods: {
    scrollToSection(n) {
      let i = n - 1,
        element = document.querySelectorAll(".page-sections section")[i];
      if (element) {
        this.scrollToElement(element);
      }
    },
    scrollObserver() {
      window.addEventListener("scroll", () => {
        this.currentScrollTop = document.documentElement.scrollTop;
      });
    },
    handleScrollChange(scrollTop) {
      const sections = document.querySelectorAll(".page-sections section");
      sections.forEach((section) => {
        let offsetTop = section.offsetTop - this.navbarHeight, // decrease navbarHeight
          offsetBottom = offsetTop + section.offsetHeight;

        if (scrollTop >= offsetTop && scrollTop < offsetBottom) {
          let sectionName = section.getAttribute("data-section");
          if (sectionName) {
            this.$store.commit("SET_ACTIVE_SECTION", sectionName);
          }
          // section is visible...
          if (section.getAttribute("data-theme") === "light") {
            if (!this.lightNavbar) {
              this.$store.commit("SET_LIGHT_NAVBAR", true);
            }
          } else {
            if (this.lightNavbar) {
              this.$store.commit("SET_LIGHT_NAVBAR", false);
            }
          }
        }
      });
    },

    ...GlobalMethods,
  },
  watch: {
    currentScrollTop(top) {
      this.handleScrollChange(top);
    },
  },

  mounted() {
    console.info("productsDetails", productsDetails);
    this.scrollObserver();
    AOS.init({
      container: document.documentElement,
      once: true,
      easing: "ease",
    });
  },
};
</script>
<style lang="scss" scoped>
section {
  .container {
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;

    &,
    * {
      z-index: 1;
    }
  }
  .bg-image {
    /* The image used */
    background: url("https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Cover%20image%201200.jpg?updatedAt=1691465556522");

    /* Add the blur effect */
    filter: blur(8px);
    -webkit-filter: blur(8px);

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  &.header-section {
    color: white;
    background-image: url("https://ik.imagekit.io/beingmuthu/FourSeasons/Reduced%20file%20size/Cover%20image%201200.jpg?updatedAt=1691465556522");
    background-size: 100% 100%; /* <------ */
    background-repeat: no-repeat;
    background-position: 0% 0%;
    backdrop-filter: blur(2px);
  }
  h1 {
    font-size: 4rem;
    font-weight: 300;

    @media (max-width: 960px) {
      text-align: center;
      font-size: 1.7rem;
      line-height: 2.4rem;
      font-weight: 400;
    }
  }
  h2 {
    font-size: 2.75rem;
    word-break: break-word !important;
    font-weight: 200;

    @media (max-width: 960px) {
      text-align: center;
      font-size: 1.3rem;
      font-weight: 300;
    }
  }
  .actions {
    z-index: 1;
    position: absolute;
    top: 80%;
    left: 31%;
    transform: translateX(-50%);
    margin-top: 3rem;
    @media (max-width: 960px) {
      margin: 2rem 0;
      width: 100%;

      text-align: center;
      justify-content: center;
    }
    .v-btn {
      @media (min-width: 960px) {
        min-width: 130px;
        min-height: 45px;
      }
    }
  }
  .section-scroll-icon {
    z-index: 2;
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
  }
  .section-title {
    text-align: center;
    .headline {
      margin-bottom: 0.5rem;
    }
    .subtitle {
      font-size: 16px;
      color: rgba(#919191, 0.75);
    }
    hr {
      width: 75px;
      margin: 2rem auto 5rem auto;
      height: 1px;
      @media (max-width: 960px) {
        margin: 2rem auto 3rem auto;
      }
    }
  }
  .product-headline {
    font-size: 26px;
    color: rgba(#000000, 0.75);
  }
  .product-section {
    @media (min-width: 1264px) {
      max-width: 1185px;
    }
    @media (min-width: 1904px) {
      max-width: 1290px;
    }
    @media (max-width: 960px) {
      padding: 16px;
    }
  }
}
</style>
